import React from 'react'
import { track } from "../../../../analytics";
import './BusinessDiscountCard.scss'
import { NavLink } from 'react-router-dom'

const BusinessDiscountCard = ({img, title, link}) => {
  const content = (
    <>
      <span className="businessDiscountCard_item" aria-hidden="true">
        {/* Иконки — одноцветные (#1D2023) png/svg с прозрачностью: как
            картинка в тёмной теме они сливались с кругом. Рисуем их
            маской, цвет берём из токена. */}
        <span className="businessDiscountCard_icon" style={{ '--icon': `url("${img}")` }} />
      </span>
      <span className="businessDiscountCard_text">{title}</span>
    </>
  )

  // tel: обычной ссылкой, маршруты — через роутер.
  if (String(link || '').startsWith('tel:')) {
    return (
      <a
        className='businessDiscountCard_block'
        href={link}
        onClick={() => track('phone_click', { number: String(link).replace('tel:', '') })}
      >
        {content}
      </a>
    )
  }

  return <NavLink className='businessDiscountCard_block' to={link || '/'}>{content}</NavLink>
}

export default BusinessDiscountCard
